export default {
  rowsPerPage: 10,
  dateInputMaxWidthNoLandscape: "290px",
  dateInputMaxWidthLandscape:   "580px",
}
